module.exports = __webpack_public_path__ + "static/img/27.49f31046.jpg";